var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFooterArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "footer-arrow",
    x: "0px",
    y: "0px",
    width: "54px",
    height: "54px",
    viewBox: "0 0 54 54",
    style: {
      enableBackground: "new 0 0 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M27,18l-6,6.4l1.5,1.6l3.5-3.7V38h2V22.3l3.5,3.7l1.5-1.6l-4.5-4.8L27,18z M27,0C12.1,0,0,12.1,0,27s12.1,27,27,27 s27-12.1,27-27S41.9,0,27,0z M27,52C13.2,52,2,40.8,2,27S13.2,2,27,2s25,11.2,25,25S40.8,52,27,52z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFooterArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/footer-arrow.dd62a680.svg";
export { ForwardRef as ReactComponent };